<template>
  <div class="room-container">
    <video autoplay="autoplay" muted="muted" loop="loop" poster="polina.jpg">
      <source src="../assets/room.mp4" type="video/mp4">
    </video>
    <div class="desc-box">
      <div class="title-box animate__animated animate__slow" :class="addAnimate">
        <p class="title">{{ title }}</p>
      </div>

      <p class="desc animate__animated animate__slow" :class="addAnimate">{{ desc }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['addAnimate'],
  data () {
    return {
      title: '华艺元空间 X 线上展馆',
      desc: '构建虚拟与现实交融的未来展示新生态'
    }
  }

}
</script>

<style lang="less" scoped>
.room-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .3);
    z-index: 2;
  }

  .desc-box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: auto;
    transform: translate(-50%, -50%);
    z-index: 3;

    .title-box {
      width: calc(100% - 40px);
      height: 80px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid #fff;
      border-radius: 40px;

      .title {
        font-size: 48px;
        font-weight: 600;
        color: #fff;
        -webkit-background-clip: text;
      }
    }

    .desc {
      width: auto;
      margin-top: 20px;
      font-size: 24px;
      color: #fff;
      letter-spacing: 1rem;
    }
  }
}
</style>